import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { StorageHelper } from '../utils/storageHelper';

/**
 * useAuth custom hook for authentication context.
 * - Provides access to authentication state and helpers.
 * - Throws if used outside an AuthProvider.
 * - Adds isLoggedIn boolean based on context token or local storage.
 *
 * @returns {Object} Auth context values and isLoggedIn flag.
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  const isLoggedIn = !!context.token || !!StorageHelper.get('token');  
  return {
    ...context,
    isLoggedIn
  };
};